import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const priceListLocaleModule: LocaleModule = {
  name: "priceList",
  messages: { en: en, it: it },
};
